const apiRoutes = {
  apiRecoverPass: '/user/recover',
  apiRecoverPassWithoutCode: '/user/password',
  apiGetUser:'/user/infouser',
  apiUpdateOwnProfile:'/user/profile',
}

export default apiRoutes
